module.exports = __webpack_public_path__ + "static/media/C-remove.89a9438f.svg";